var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddContact({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      zoom: 1.3,
      marginLeft: "-1px"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4ZM7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7C17 9.76142 14.7614 12 12 12C9.23858 12 7 9.76142 7 7ZM9.92597 14.2049C10.1345 14.7163 9.889 15.2999 9.3776 15.5084C7.06131 16.453 5.5 18.5813 5.5 20.9999C5.5 21.5522 5.05228 21.9999 4.5 21.9999C3.94772 21.9999 3.5 21.5522 3.5 20.9999C3.5 17.6777 5.641 14.8723 8.6224 13.6565C9.1338 13.448 9.71743 13.6935 9.92597 14.2049Z",
    fill: "#10A37F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.596V20.798C17 21.2388 17.3574 21.596 17.798 21.596C18.2385 21.5958 18.5949 21.2385 18.5949 20.798V18.596H20.798C21.2385 18.5958 21.5949 18.2385 21.5949 17.798C21.5949 17.3575 21.2385 17.0002 20.798 17H18.5949V14.798C18.5949 14.3575 18.2385 14.0002 17.798 14C17.3574 14 17 14.3572 17 14.798V17H14.798C14.3574 17 14 17.3572 14 17.798C14 18.2388 14.3574 18.596 14.798 18.596H17Z",
    fill: "#10A37F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddContact);
export default __webpack_public_path__ + "static/media/icon-add-contact.b77b2b1b0e9945f6c4a581ec1c0fdf0b.svg";
export { ForwardRef as ReactComponent };